'use strict';
module.exports = {
    ACCOUNT_ASSIGNMENT_DETAIL: {
        id: 'ACCOUNT_ASSIGNMENT_DETAIL',
        templatePath: `./${BUILD_PATH}/account-assignment-detail.dialog.html`
    },
    BPMN_DISPLAY: {
        id: 'BPMN_DISPLAY',
        templatePath: `./${BUILD_PATH}/bpmn-display.dialog.html`
    },
    CLIENT_WAREHOUSE_INSERT: {
        id: 'CLIENT_WAREHOUSE_INSERT',
        templatePath: `./${BUILD_PATH}/insert-into-warehouse.dialog.html`
    },
    ORDER_ACKNOWLEDGEMENT_CREATE: {
        id: 'ORDER_ACKNOWLEDGEMENT_CREATE',
        templatePath: `./${BUILD_PATH}/order-acknowledgement-create.dialog.html`
    },
}
